"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import Context from "@/context/Context";
import MobileMenu from "@/components/modals/MobileMenu";

import ScrollTop from "@/components/common/ScrollTop";
import Header4 from "@/components/headers/Header4";
import Footer1 from "@/components/footers/Footer1";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CookieBanner from "@/components/CookieBanner";
import ChatWidget from "@/components/chatbot/ChatWidget";
import { usePWA } from "@/utlis/usePWA";
import { useIsLoggedIn } from "@/utlis/useIsLoggedIn";
import BottomNav from "@/components/BottomNav";

export default function ClientShell({ children }) {
	const pathname = usePathname();
	const isPWA = usePWA();
	const isAuthPage =
		pathname.startsWith("/autentificare") ||
		pathname.startsWith("/inregistrare") ||
		pathname.startsWith("/reseteaza-parola");
	const isLoggedIn = useIsLoggedIn();

	useEffect(() => {
		if (!pathname.includes("/admin") && !isAuthPage) {
			const handleScroll = () => {
				const header = document.querySelector("header");
				if (!header) return;
				if (window.scrollY > 100) {
					header.classList.add("header-bg");
				} else {
					header.classList.remove("header-bg");
				}
			};

			window.addEventListener("scroll", handleScroll);

			return () => {
				window.removeEventListener("scroll", handleScroll);
			};
		}
	}, []);

	const [scrollDirection, setScrollDirection] = useState("down");

	useEffect(() => {
		if (!pathname.includes("/admin")) {
			setScrollDirection("up");
			const handleScroll = () => {
				const currentScrollY = window.scrollY;

				if (currentScrollY > 250) {
					if (currentScrollY > lastScrollY.current) {
						setScrollDirection("down");
					} else {
						setScrollDirection("up");
					}
				} else {
					setScrollDirection("down");
				}

				lastScrollY.current = currentScrollY;
			};

			const lastScrollY = { current: window.scrollY };

			window.addEventListener("scroll", handleScroll);

			return () => {
				window.removeEventListener("scroll", handleScroll);
			};
		}
	}, [pathname]);

	useEffect(() => {
		const bootstrap = require("bootstrap");
		const modalElements = document.querySelectorAll(".modal.show");
		modalElements.forEach((modal) => {
			const modalInstance = bootstrap.Modal.getInstance(modal);
			if (modalInstance) {
				modalInstance.hide();
			}
		});

		// Close any open offcanvas
		const offcanvasElements = document.querySelectorAll(".offcanvas.show");
		offcanvasElements.forEach((offcanvas) => {
			const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvas);
			if (offcanvasInstance) {
				offcanvasInstance.hide();
			}
		});
	}, [pathname]);

	useEffect(() => {
		if (!pathname.includes("/admin") && !isAuthPage && !isPWA) {
			const header = document.querySelector("header");
			if (header) {
				if (scrollDirection == "down") {
					header.style.top = "0px";
				} else {
					header.style.top = "-185px";
				}
			}
		}
	}, [scrollDirection, isPWA]);

	useEffect(() => {
		const { WOW } = require("wowjs");
		const wow = new WOW({
			mobile: false,
			live: false,
		});
		wow.init();
	}, [pathname]);

	useEffect(() => {
		document.documentElement.dir = "ltr";
		const preloader = document.getElementById("preloader");
		if (preloader) preloader.classList.add("disabled");
	}, []);

	useEffect(() => {
		if (!("serviceWorker" in navigator)) return;
		if (sessionStorage.getItem("sw-cleanup-done")) return;

		navigator.serviceWorker.getRegistrations().then((regs) => {
			if (regs.length === 0) {
				sessionStorage.setItem("sw-cleanup-done", "1");
				return;
			}
			Promise.all(regs.map((reg) => reg.unregister())).then(() => {
				const clearCaches = "caches" in window
					? caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
					: Promise.resolve();
				clearCaches.then(() => {
					sessionStorage.setItem("sw-cleanup-done", "1");
					window.location.reload();
				});
			});
		});
	}, []);

	return (
		<>
			<div className='preload preload-container' id='preloader'>
				<div className='preload-logo'>
					<div className='spinner'></div>
				</div>
			</div>{" "}
			<Context>
				{!pathname.includes("/admin") && !isAuthPage && <Header4 />}
				<ToastContainer />
				<main id='wrapper'>
                         {children}
                    </main>
				{!pathname.includes("/admin") && !isAuthPage && isPWA && <BottomNav userState={isLoggedIn} />}
				{!pathname.includes("/admin") && !isAuthPage && <CookieBanner />}
				{!pathname.includes("/admin") && !isAuthPage && <ChatWidget />}
				{!pathname.includes("/admin") && !isAuthPage && <MobileMenu />}

				{!pathname.includes("/admin") && !isAuthPage && !isPWA && <Footer1 />}
			</Context>
			<ScrollTop />
		</>
	);
}
